let Tarray = new Array(10);

for (let i = 0; i < Tarray.length; i++) {
  Tarray[i] = new Array(20);
  for (let j = 0; j < Tarray[i].length; j++) {
    Tarray[i][j] = false;
  }
}
export default Tarray;
